import {deleteNote, newNote, notes, updateNote} from "../../api";

export default {
    state: {
        all: []
    },
    actions: {
        fetchNotes(context) {
            let token = context.getters.getToken.jwt;
            return notes({token});
        },

        newProjectNote(context, note) {
            let token = context.getters.getToken.jwt;

            return newNote({token, note});
        },

        updateProjectNote(context, note) {
            let token = context.getters.getToken.jwt;

            return updateNote({token, note});
        },

        deleteProjectNote(context, note) {
            let token = context.getters.getToken.jwt;

            return deleteNote({token, note});
        },
    },
    mutations: {},
    getters: {}
}